// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f1e5e854","453":"65eb3571"}[chunkId] + ".chunk.js";
};